import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const DELETE_CONVERSATION = 'DELETE_CONVERSATION';
export const DELETE_CONVERSATION_SUCCESS = 'DELETE_CONVERSATION_SUCCESS';
export const DELETE_CONVERSATION_FAIL = 'DELETE_CONVERSATION_FAIL';
export const DELETE_CONVERSATION_RESET = 'DELETE_CONVERSATION_RESET';

export const deleteConversation = (params) => {
	return {
		type: DELETE_CONVERSATION,
		params,
	};
};

export const deleteConversationSuccess = (response) => {
	return {
		type: DELETE_CONVERSATION_SUCCESS,
		response,
	};
};

export const deleteConversationFail = (response) => {
	return {
		type: DELETE_CONVERSATION_FAIL,
		response,
	};
};

export const deleteConversationReset = () => {
	return {
		type: DELETE_CONVERSATION_RESET,
	};
};

export const deleteConversationApi = (data) => {
	return (dispatch) => {
		dispatch(deleteConversation());
		axios
			.post(`${config.api.base_url}/voice-assistance/delete`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deleteData = response.data;
				dispatch(deleteConversationSuccess(deleteData));
			})
			.catch((error) => {
				const errorMsg = error.response
					? error.response.data
					: error.message;
				dispatch(deleteConversationFail(errorMsg));
			});
	};
};
